<template>
    <div>
        <div class="card">
            <div class="card-body">
                <div class="row">
                    <div class="col-md-6">
                        <h3>ANÁLISIS DE LABORATORIO DE TICKETS</h3>
                    </div>
                    <div class="col-md-6">
                        <button class="btn btn-sm btn-primary float-right" v-if="analisis_id == null"
                            @click="crearAnalisis">CREAR</button>
                        <!-- <button class="btn btn-sm btn-primary float-right" v-if="analisis_id != null" @click="actualizarAnalisis">ACTUALIZAR</button> -->
                        <button class="btn btn-sm btn-primary float-right" v-if="analisis_id != null"
                            @click="verificar_parametros">ACTUALIZAR</button>

                    </div>
                    <!-- <pre>Analisis: {{analisis}}</pre> -->
                </div>
                <div class="row">
                    <div class="col">
                        <div class="card">
                            <table class="table table-bordered">
                                <thead class="thead-blue1">
                                    <tr>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            <i class="fas fa-clipboard-check"
                                                :title="`N° Analisis: ${analisis_id}`"></i>
                                            TICKET
                                        </th>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">FECHA TICKET
                                        </th>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">MATERIA
                                            PRIMA</th>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">PATENTE</th>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">MUESTREADOR
                                        </th>


                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            {{ ticket.codigo_ticket }}</td>
                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            {{ ticket.fecha_hora_ticket | fecha_hora }}</td>
                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            {{ ticket.materia_prima_texto }}</td>
                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            {{ ticket.patente }}</td>
                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            <select name="" id="" v-model="muestreador_id">
                                                <option value="">-- seleccione muestreador --</option>
                                                <option :value="a.id" v-for="a in muestreadores" :key="a.id">{{ a.name
                                                }}
                                                </option>
                                            </select>
                                        </td>


                                        <!-- <td class="text-center"><span class="text-center" v-if="ticket">{{ticket.fecha_hora_ticket | fecha_hora}}</span></td>
                                        <td class="text-center"><span class="text-center" v-if="ticket">{{ticket.materia_prima_texto}}</span></td>
                                        <td class="text-center"><span class="text-center" v-if="ticket">{{ticket.patente}}</span></td> -->
                                    </tr>
                                </tbody>
                            </table>

                            <table class="table table-bordered">
                                <thead class="thead-blue1 mt-1">
                                    <tr>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">N° GUÍA</th>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">PROVEEDOR
                                        </th>
                                        <th class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">SUCURSAL
                                        </th>
                                        <!-- <th class="text-center">PESO ROMANA (KG)</th> -->

                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="g in guias" :key="g.id">

                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            {{ g.numero_guia }}</td>
                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            {{ g.empresa_texto }}</td>
                                        <td class="text-center"
                                            style="font-size:14px; font-weight:bold; padding:0.25em 0.5em;">
                                            {{ g.sucursal_texto }}</td>


                                        <!-- <td class="text-center">
                                        {{g.numero_guia}}
                                    </td>
                                    <td class="text-center">{{g.empresa_texto}}</td>
                                    <td class="text-center">{{g.sucursal_texto}}</td> -->
                                        <!-- <td class="text-center">{{g.peso_real}}</td> -->
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>





            </div>
        </div>
        <!-- <pre>{{items_analisis}}</pre> -->
        <!-- <pre>{{items}}</pre> -->
        <!-- <pre>{{parametros}}</pre> -->

        <div class="row">
            <div class="col">
                <div :class="`alert ${alert_clase} alert-dismissible fade show`" role="alert" v-if="alert">
                    <span class="alert-icon"><i class="fas fa-check"></i></span>
                    <!-- <span class="alert-text"><strong>Error de Validación!</strong></span> -->
                    <span class="alert-text"> <strong>{{ `${alert_mensaje}` }}</strong></span>

                    <button type="button" class="close" @click="alert = !alert" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div :class="`alert alert-warning alert-dismissible fade show`" role="alert"
                    v-if="mensajes_correo.length > 0">
                    <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
                    <!-- <span class="alert-text"><strong>Error de Validación!</strong></span> -->
                    <span class="alert-text" v-for="m in mensajes_correo" :key="m"> <strong>{{ `${m}` }}</strong></span>

                    <button type="button" class="close" @click="mensajes_correo = []" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col">
                <div :class="`alert alert-primary alert-dismissible fade show`" role="alert" v-if="alert_2"
                    style="background-color:rgba(242, 65, 65,0.5);color:black">
                    <span class="alert-icon"><i class="fas fa-exclamation-triangle"></i></span>
                    <!-- <span class="alert-text"><strong>Error de Validación!</strong></span> -->
                    <span class="alert-text"> <strong>Atención!</strong> El archivo que esta intentando subir excede el
                        limite permitido por el Servidor (40 MB),
                        su archivo pesa</span>
                    <span class="badge badge-pill badge-lg bg-gradient-success">{{ size }} MB</span>

                    <button type="button" class="close" @click="close_alert_2" aria-label="Close">
                        <span aria-hidden="true" style="color:black">&times;</span>
                    </button>
                </div>
            </div>
        </div>

        <div class="card" v-show="analisis_id != null">
            <div class="card-body table-responsive">
                <!-- <div class="row" v-for="item in items" :key="item.id">
                    <table class="table table-bordered">
                        <thead class="background-salmon-3">
                            <tr>
                                <th style="font-size:16px;padding:0.25em 0.5em !important;" :colspan="item.cantidad_parametros"><strong>{{item.nombre}}</strong></th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td v-for="(par,idx) in devolver_parametros(item.id)" :key="idx" style="padding:0.25em 0.75em;">
                                    <div class="form-group">
                                        <label for="form-control-label mr-3"><strong style="font-size:16px;">{{`${par.nombre} ${par.unidad_medida_texto}`}}</strong><span v-if="par.maximo != '-'" style="padding-left:10px;"> ( máx. {{`${par.maximo}`}} ) </span></label>
                                        <input style="padding:0.25em !important; height:2em;" v-if="par.tipo_dato_texto == 'Numero'" :class="[{'form-control':true,'input-rojo-1':calcular_alerta(par)}]" type="number" v-model="par.valor">
                                        <input style="padding:0.25em !important; height:2em;" v-if="par.tipo_dato_texto == 'Texto'" :class="[{'form-control':true}]" type="text" v-model="par.valor_texto">
                                        <textarea class="form-control" v-if="par.tipo_dato_texto == 'Textarea'" name="" id="" cols="30" rows="5" v-model="par.valor_texto"></textarea>
                                        

                                        <input v-if="par.tiene_adjunto == 1" type="file" @change="subirArchivo($event,par)">
                                        <button class="btn btn-sm btn-danger" v-if="par.tiene_adjunto == 1 && par.ruta_archivo" @click="verArchivo(par.link)"> <i class="fas fa-file-image"></i> Ver</button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div> -->


                <table class="table table-bordered">
                    <tbody>
                        <tr v-for="item in items" :key="item.id">


                            <td bgcolor="#ffc59e"
                                style="color:#000;font-weight:bold;font-size:1em;text-align:center;vertical-align:middle;width:100px;">
                                {{ item.nombre }}</td>

                            <td v-for="(par, idx) in devolver_parametros(item.id)" :key="idx"
                                style="padding:0.25em 0.75em; width:50px;">

                                <div class="form-group" style="margin-bottom:0.3em;">
                                    <div class="flex-row">
                                        <label for="form-control-label mr-3" style="margin-bottom:0.1em;"><strong
                                                style="font-size:1.1em;" :title="`ID: ${par.id}`">{{ `${par.nombre}
                                                ${par.unidad_medida_texto}` }}</strong><span v-if="par.maximo != '-'"
                                                style="padding-left:10px;"> ( máx. {{ `${par.maximo}` }} )
                                            </span></label>
                                        <i class="fas fa-bell ml-2" title="Alerta Enviada"
                                            style="color:#ff5100;font-size:0.9rem" v-if="par.alerta_enviada == 1"></i>
                                    </div>
                                    <div class="flex-row" v-if="par.tipo_dato_texto == 'Numero'">
                                        <input style="padding:0.25em !important; height:2em;width:80px;"
                                            v-if="par.tipo_dato_texto == 'Numero'"
                                            :class="[{ 'form-control': true, 'input-rojo-1': calcular_alerta(par) }]"
                                            type="number" v-model="par.valor" :disabled="par.calculado">
                                        <span v-if="par.calculado"
                                            class="badge badge-pill badge-lg bg-warning text-white ml-2"
                                            title="Parámetro Calculado"><i class="fas fa-calculator"
                                                style="font-size:0.9rem"></i></span>
                                    </div>

                                    <input style="padding:0.25em !important; height:2em;"
                                        v-if="par.tipo_dato_texto == 'Texto'" :class="[{ 'form-control': true }]"
                                        type="text" v-model="par.valor_texto">
                                    <textarea class="form-control" v-if="par.tipo_dato_texto == 'Textarea'" name=""
                                        id="" cols="30" rows="2" v-model="par.valor_texto"></textarea>
                                    <button class="btn btn-sm btn-danger"
                                        v-if="par.tiene_adjunto == 1 && par.ruta_archivo" @click="verArchivo(par.link)">
                                        <i class="fas fa-file-image"></i> Ver</button>

                                    <input v-if="par.tiene_adjunto == 1" type="file" @input="subirArchivo($event, par)"
                                        class="mt-2">
                                    <span></span>
                                    <button v-if="mostrar_restablecer && par.id != null && par.alerta_enviada == 1"
                                        class="btn btn-sm btn-info mt-1" :title="`restablecer ${par.id}`"
                                        @click="restablecer(par.id)">
                                        <i class="fas fa-sync"></i>
                                    </button>
                                </div>
                            </td>

                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
        <!-- <pre>{{parametros}}</pre> -->
        <!--<pre>{{ productos_recibidos_id }}</pre>-->

        <vue-confirm-dialog></vue-confirm-dialog>
    </div>
</template>
<script>
import { mapState } from 'vuex';

export default {
    data: () => ({
        //tickets:[],
        guias: [],
        disabled_guia: true,
        analisis_id: null,
        tickets_id: null,
        guias_id: null,
        ticket: {},
        //guia_id:undefined,
        items_analisis: [],
        parametros: [],
        muestreadores: [],
        analisis: null,
        muestreador_id: "",
        detalles: [],
        errores: {},
        alert: false,
        alert_mensaje: '',
        alert_clase: '',
        mensajes_correo: [],
        alert_2: false,
        size: null,
        productos_recibidos_id: []
    }),
    mounted() {
        //this.tickets_id = this.$route.params.id;
        //console.log
        this.cargarAnalistas();
        this.cargarProductosRecibidosIds();
    },
    methods: {
        async cargarAnalistas() {
            this.tickets_id = this.$route.params.id;
            await this.axios.get(`${this.api}/users/muestreadores`, this.cabeceras_json).then((res) => {
                this.muestreadores = res.data.data;
            }).catch((e) => {
                //console.log(e);
            });
            await this.cargarTicket();
        },
        async cargarProductosRecibidosIds() {
            this.tickets_id = this.$route.params.id;
            await this.axios.get(`${this.api}/tickets/${this.tickets_id}/productos-recibidos`, this.cabeceras_json).then((res) => {
                this.productos_recibidos_id = res.data.productos_recibidos_id;
            }).catch((e) => {
                //console.log(e);
            });
        },

        validarProductosRecibidos(ids) {
            if (!Array.isArray(ids) || ids.length === 0) return true;

            const recibidos = Array.isArray(this.productos_recibidos_id)
                ? this.productos_recibidos_id
                : [this.productos_recibidos_id];

            const set = new Set(recibidos);
            return ids.some(id => set.has(id));
        },
        async cargarTicket() {
            this.tickets_id = this.$route.params.id;
            await this.axios.get(`${this.api}/tickets/${this.tickets_id}`, this.cabeceras_json).then((res) => {
                this.ticket = { ...res.data.data }
                //this.ticket = res.data.data;
                //this.guia_id = undefined;
                //console.log('tickets',this.ticket);
            }).catch((e) => {
                //console.log(e);
            });
            await this.cargar_analisis();
        },

        async cargar_guias() {
            await this.axios.get(`${this.api}/guias?tickets_id=${this.tickets_id}&&limit=9999999`, this.cabeceras_json).then(async (res) => {
                ////console.log(res.data.data.data);
                this.guias = res.data.data.data;
                //await this.cargarParametrosMateriaPrima();
                //await this.cargar_analisis();
            }).catch((e) => {
                //console.log(e);
            });
        },

        async crearAnalisis() {
            let body = {
                tickets_id: this.tickets_id,
                muestreador_id: this.muestreador_id
                //guias_id:this.guias_id
            };

            await this.axios.post(`${this.api}/lab_analisis`, body, this.cabeceras_json).then((res) => {
                //console.log('res_analisis',res.data.data);
                if (res.data.codigo == 200) {
                    this.alert = false;
                    this.errores = {};
                    this.analisis = res.data.data;
                    this.analisis_id = this.analisis.id;
                    this.tickets_id = this.analisis.tickets_id;
                    this.guias_id = this.analisis.guias_id;
                } else {
                    //error de validacion
                    this.errores = res.data.data;
                    this.alert = true;
                    this.analisis = null;
                    this.analisis_id = null;
                    //console.log('error validacion',res.data);
                }
            }).catch((e) => {
                //console.log(e);
            });
            this.setearParametros();
        },

        calcular_alerta(parametro) {
            let minimo = parametro.valor_minimo;
            let maximo = parametro.valor_maximo;
            let valor = parametro.valor;
            let alerta = false;

            if (minimo != null && maximo != null) {
                alerta = valor < minimo || valor > maximo ? true : false
            }
            else if (minimo != null && maximo == null) {
                alerta = valor < minimo ? true : false;
            }

            else if (minimo == null && maximo != null) {
                alerta = valor > maximo ? true : false;
            }

            if (valor == null || valor == '') {
                alerta = false;
            }
            return alerta;
            //return valor < minimo || valor > maximo ? true:false;
        },

        async actualizarAnalisis() {
            let body = {
                lab_analisis: this.analisis,
                muestreador_id: this.muestreador_id,
                lab_analisis_detalles: this.parametros
            }
            await this.axios.put(`${this.api}/lab_analisis/${this.analisis_id}`, body, this.cabeceras_json).then((res) => {
                console.log('Actualizacion Realizada', res.data.data);
                this.detalles = res.data.data.data;
                this.mensajes_correo = res.data.data.messages_correo;
                this.setearParametros();

                this.alert_mensaje = res.data.mensaje;
                this.alert_clase = 'alert-success';
                this.alert = true;
            }).catch((e) => {
                //console.log(e);
            });
        },

        async verificar_parametros() {
            let body = {
                lab_analisis: this.analisis,
                lab_analisis_detalles: this.parametros
            }
            await this.axios.post(`${this.api}/lab_analisis/${this.analisis_id}/verificar_parametros`, body, this.cabeceras_json).then((res) => {
                let alerta = res.data.data.alertas;
                let mensajes = res.data.data.mensajes;
                if (alerta) {
                    let texto = '';
                    let char = '';
                    let total = mensajes.length;
                    let num = 1;
                    mensajes.forEach(m => {
                        if (num == total) {
                            char = '';
                        }
                        texto += `${m.parametro} ${m.unidad_medida} : ${m.valor} ${m.min_max} ${char}`;
                    });
                    this.$confirm({
                        title: `Se Generarán las siguientes Alertas`,
                        message: texto,
                        button: {
                            no: 'Cancelar',
                            yes: 'Confirmar'
                        },
                        /**
                        * Callback Function
                        * @param {Boolean} confirm
                        */
                        callback: async confirm => {
                            if (confirm) {
                                this.actualizarAnalisis();
                            }
                        }
                    })

                } else {
                    this.actualizarAnalisis();
                }
                //this.alert_mensaje = res.data.mensaje;
                //this.alert_clase = 'alert-success';
                //this.alert = true;
            }).catch((e) => {
                //console.log(e);
            });
        },

        async cargarParametrosMateriaPrima() {
            await this.axios.get(`${this.api}/lab_item_analisis/mp_tipos_id/${this.ticket.mp_tipos_id}/${this.tickets_id}`, this.cabeceras_json).then((res) => {
                ////console.log(res.data.data)
                this.items_analisis = res.data.data;
                /* this.items_analisis.forEach(i=>{
                    i.parametros_activos.forEach(p=>{
                        p.valor = '';
                    });
                }) */
                //this.setearParametros();
            }).catch((e) => {
                //console.log(e);
            });
        },



        async cargar_analisis() {
            if (this.tickets_id) {
                await this.axios.get(`${this.api}/lab_analisis/obtener_analisis/${this.tickets_id}`, this.cabeceras_json).then((res) => {
                    //console.log('lab_analisis',res.data.data);
                    this.analisis = res.data.data.lab_analisis;
                    this.detalles = res.data.data.lab_analisis_detalles;
                    this.ticket = res.data.data.ticket;
                    if (this.analisis != null) {
                        this.analisis_id = this.analisis.id;
                        this.tickets_id = this.analisis.tickets_id;
                        this.guias_id = this.analisis.guias_id;
                        this.muestreador_id = this.analisis.muestreador_id != null ? this.analisis.muestreador_id : "";
                    } else {
                        this.analisis_id = null;
                    }
                }).catch((e) => {
                    //console.log(e);
                });
                await this.cargarParametrosMateriaPrima();
                await this.setearParametros();
                await this.cargar_guias();
            } else {
                this.ticket = null;
                this.analisis = null;
                this.items_analisis = [];
                this.detalles = [];
                this.guias = [];
            }
        },

        async subirArchivo($e, parametro) {
            //console.log($e,parametro);

            this.file = $e.target.files[0];
            //console.log('file',this.file);
            if (this.file.size > 40000000) {
                //40 megabytes
                this.size = this.file.size / 1000000;
                this.alert_2 = true
                $e.target.value = '';
            } else {
                let formData = new FormData();
                formData.append('file', this.file);
                formData.append('lab_analisis_id', this.analisis.id);
                formData.append('lab_item_parametros_id', parametro.lab_item_parametros_id);

                await this.axios.post(`${this.api}/subir_archivo_analisis`, formData, this.cabeceras_archivo).then((res) => {
                    //console.log('archivito',res.data.lab_analisis_detalle);

                    let index = this.parametros.findIndex(p => p.lab_item_parametros_id == parametro.lab_item_parametros_id);
                    //console.log('parametro archivo',this.parametros[index]);
                    this.$set(this.parametros[index], 'id', res.data.lab_analisis_detalle.id);
                    this.$set(this.parametros[index], 'ruta_archivo', res.data.lab_analisis_detalle.ruta_archivo);
                    this.$set(this.parametros[index], 'link', res.data.lab_analisis_detalle.link);
                })
                    .catch((e) => {
                        //console.log(e);
                    });
            }

        },

        setearParametros() {
            this.parametros = [];

            this.items_analisis.forEach(item => {
                item.lab_item_parametros.forEach(par => {

                    // 🔎 FILTRO AQUÍ
                    if (!this.validarProductosRecibidos(par.productos_recibidos_ids)) {
                        return; // no se agrega el parámetro
                    }

                    let det = this.detalles.find(
                        d => d.lab_item_parametros_id == par.id
                    );

                    this.parametros.push({
                        id: det ? det.id : null,
                        tipo_dato_texto: par.parametro.tipo_dato_texto,
                        lab_item_analisis_id: par.lab_item_analisis_id,
                        lab_analisis_id: this.analisis ? this.analisis.id : null,
                        lab_item_parametros_id: par.id,
                        valor: det ? Math.round10(det.valor, -1) : '',
                        valor_texto: det ? det.valor_texto : '',
                        ruta_archivo: det ? det.ruta_archivo : '',
                        link: det ? det.link : '',
                        nombre: par.parametro.nombre,
                        unidad_medida_texto: par.parametro.unidad_medida_texto,
                        pasos_formulas: par.pasos_formulas,
                        calculado: par.pasos_formulas.length > 0,
                        maximo: par.maximo,
                        tiene_adjunto: par.tiene_adjunto,
                        alerta_enviada: det ? det.alerta_enviada : 0,
                        alerta: false
                    });
                });
            });
        },

        devolver_parametros(lab_item_analisis_id) {
            return this.parametros_calculados.filter(p => p.lab_item_analisis_id == lab_item_analisis_id);
        },

        verArchivo(link) {
            window.open(link, '_blank');
        },

        async restablecer(id) {
            await this.axios.post(`${this.api}/restablecer_alerta/${id}`, {}, this.cabeceras_json).then(r => {

            }).catch(e => {

            })
        },
        close_alert_2() {
            this.size = null
            this.alert_2 = false
        }
    },
    computed: {

        mensaje_alert() {
            let devolver = [];
            Object.keys(this.errores).forEach(key => {
                let array = this.errores[key];
                array.forEach(mensaje => {
                    devolver.push(mensaje);
                });
            });
            return devolver;
        },

        items() {
            let array = [];
            this.items_analisis.forEach(item => {

                let i = {
                    id: item.id,
                    nombre: item.nombre,
                    cantidad_parametros: item.cantidad_parametros
                }

                array.push(i);
            });

            return array;
        },

        parametros_calculados() {
            let array = [];
            this.parametros.forEach(par => {
                if (par.pasos_formulas.length > 0) {
                    let valor_anterior = null;
                    let valor_final = null;
                    let setear = true;

                    par.pasos_formulas.forEach(paso => {
                        let valor_1 = null;
                        let valor_2 = null;
                        if (paso.tipo_valor_1 == 'numero') {
                            valor_1 = paso.valor_1;
                        }
                        if (paso.tipo_valor_1 == 'resultado_anterior') {
                            valor_1 = valor_anterior;
                        }
                        if (paso.tipo_valor_1 == 'parametro') {
                            valor_1 = this.parametros.find(p => p.lab_item_parametros_id == paso.lab_item_parametros_id1).valor;
                            if (valor_1) {
                                valor_1 = valor_1;
                                //setear = true;
                            } else {
                                setear = false
                            }
                        }


                        if (paso.tipo_valor_2 == 'numero') {
                            valor_2 = paso.valor_2;
                        }
                        if (paso.tipo_valor_2 == 'parametro') {
                            valor_2 = this.parametros.find(p => p.lab_item_parametros_id == paso.lab_item_parametros_id2).valor;
                            if (valor_2) {
                                valor_2 = valor_2;
                                //setear = true;
                            } else {
                                setear = false
                            }
                        }
                        if (paso.tipo_valor_2 == 'resultado_anterior') {
                            valor_2 = valor_anterior;
                        }

                        //let resultado = null;
                        if (valor_1 && valor_2) {
                            //setear = true;
                        }

                        if (paso.operador == '+') {
                            valor_final = valor_1 + valor_2;
                        }

                        if (paso.operador == '-') {
                            valor_final = valor_1 - valor_2;
                        }

                        if (paso.operador == '*') {
                            valor_final = valor_1 * valor_2;
                        }

                        if (paso.operador == '/') {
                            valor_final = valor_1 / valor_2;
                        }

                        valor_anterior = valor_final;
                        //valor_final = resultado;
                    })

                    //verificar que todos los que son parametro tengan un valor
                    if (setear) {
                        //par.valor = valor_final;
                        par.valor = Math.round10(valor_final, -1);

                    }
                }
            });
            return this.parametros;
        },

        mostrar_restablecer() {
            let esta = this.permisos_rom.find(p => p == 'ROMANA_LabAnalisisController_restablecer_alerta');
            return esta ? true : false;
        },

        materia_prima() {
            return this.ticket != null ? this.ticket.materia_prima_texto : ''
        },

        productosRecibidosUnicos() {
            const ids = new Set();

            if (!this.ticket || !Array.isArray(this.ticket.guias_romana)) {
                return [];
            }

            this.ticket.guias_romana.forEach(guia => {
                if (!Array.isArray(guia.distribuciones)) return;

                guia.distribuciones.forEach(dist => {
                    if (dist.productos_recibidos_id != null) {
                        ids.add(dist.productos_recibidos_id);
                    }
                });
            });

            return Array.from(ids);
        },
        ...mapState(['api', 'cabeceras_json', 'cabeceras_archivo', 'permisos_rom'])
    }
}
</script>
